export default __webpack_public_path__ + "static/media/process-1.4402f79f.svg";